import { c as _c } from "react/compiler-runtime";
import { Text } from "@flat-ui";
import { Image360NoImageIcon } from "@flat-ui";
import { Stack } from "@mui-wrapper";

/** Empty state of the project stats, with the same look as the empty annotations summary */
export function ProjectChartEmpty() {
  const $ = _c(8);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      gap: 2
    };
    t1 = <Text variant="heading16">Total 360° images</Text>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      textAlign: "center",
      gap: 2
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "7.5rem",
      height: "7.5rem",
      borderRadius: "50%",
      backgroundColor: "surfaces.secondary",
      justifyContent: "center",
      alignItems: "center"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Stack sx={t3}><Image360NoImageIcon sx={{
        width: "2.5rem",
        height: "2.5rem"
      }} /></Stack>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      gap: 0.5
    };
    t6 = <Text variant="heading20">No 360° images</Text>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Stack sx={t0}>{t1}<Stack sx={t2}>{t4}<Stack sx={t5}>{t6}<Text variant="bodyM" sx={{
            color: "text.secondary"
          }}>There are no 360° images in this project yet.</Text></Stack></Stack></Stack>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}